import { useAuthContext } from '@/contexts/AuthContext';
import { useAvatar } from '@/hooks/useAvatar';
import { PhotoUploadSheet } from '@/components/common/PhotoUploadSheet';

/**
 * Foto de perfil do utilizador: avatar circular + bottom sheet (mesma UI do app
 * do cliente). A validação (PNG/JPG/WEBP, ≤2MB) vive em useAvatar.
 */
export function AvatarUploadCard() {
  const { profile } = useAuthContext();
  const { uploadAvatar, removeAvatar, isUploading, isRemoving } = useAvatar();

  const inicial = profile?.nome?.charAt(0)?.toUpperCase() || '?';

  return (
    <div className="flex justify-center">
      <PhotoUploadSheet
        imageUrl={profile?.avatar_url}
        fallback={inicial}
        onPick={uploadAvatar}
        onRemove={removeAvatar}
        busy={isUploading || isRemoving}
        canRemove={!!profile?.avatar_url}
        caption={
          profile?.nome ? (
            <div className="text-center text-lg font-bold text-foreground">{profile.nome}</div>
          ) : null
        }
      />
    </div>
  );
}
